import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {QRDownloadComponent} from './qrdownload.component';

const routes: Routes = [{
  path: '',
  component: QRDownloadComponent
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class QRDownloadRoutingModule {
}
